import { useRef, useState } from 'react';
import { toast } from 'sonner';

import { AI_TOAST_MESSAGES } from '@/components/shared/ai-menu-constants';
import { formatErrorMessage } from '@/lib/utils';
import { useAiOperationsStore } from '@/stores/ai-operations-store';
import { usePagesActions } from '@/stores/pages-store';

export function useCreateBlankPage() {
  const creatingRef = useRef(false);
  const [isCreating, setIsCreating] = useState(false);
  const { createPage } = usePagesActions();

  const createBlankPage = async () => {
    if (creatingRef.current) return;
    if (useAiOperationsStore.getState().isStreaming) {
      toast.error(AI_TOAST_MESSAGES.OPERATION_IN_PROGRESS);
      return;
    }

    creatingRef.current = true;
    setIsCreating(true);
    try {
      await createPage(
        { pageType: 'blank' },
        {
          onError: (errors) => toast.error(formatErrorMessage(errors, 'Failed to create page')),
        },
      );
    } catch (error) {
      toast.error(formatErrorMessage(error, 'Failed to create page'));
    } finally {
      creatingRef.current = false;
      setIsCreating(false);
    }
  };

  return { createBlankPage, isCreating };
}
